const SavedPostSkeleton = () => {
  return (
    <div className="relative w-full overflow-hidden rounded-2xl border border-gray-200 dark:border-slate-700 animate-pulse">
      <div className="p-6 space-y-4">
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-slate-700" />
          <div className="space-y-2">
            <div className="h-3 w-24 bg-gray-200 dark:bg-slate-700 rounded" />
            <div className="h-3 w-16 bg-gray-200 dark:bg-slate-700 rounded" />
          </div>
        </div>

        {/* Content */}
        <div className="space-y-2">
          <div className="h-4 w-full bg-gray-200 dark:bg-slate-700 rounded" />
          <div className="h-4 w-5/6 bg-gray-200 dark:bg-slate-700 rounded" />
          <div className="h-4 w-2/3 bg-gray-200 dark:bg-slate-700 rounded" />
        </div>

        {/* Actions */}
        <div className="flex justify-between items-center pt-2">
          <div className="h-8 w-20 bg-gray-200 dark:bg-slate-700 rounded" />
          <div className="h-8 w-24 bg-gray-200 dark:bg-slate-700 rounded" />
        </div>
      </div>
    </div>
  );
};

export default SavedPostSkeleton;